/** Интервал debounce для текстовых фильтров (поиск → query в URL). */
export const TEXT_FILTER_DEBOUNCE_MS = 300
